<template>
  <v-flex md12>
    <material-card
      color="success"
      title="Propostas"
      text="Propostas enviadas para o Lead"
    >
      <v-layout fluid wrap text-xs-rigth>
        <v-flex sm12 md8>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md4 text-xs-right text-md-right>
          <v-btn
            class="mx-0 font-weight-light"
            color="secondary"
            @click.prevent="newProposal()"
          >
            <v-icon left dark>add</v-icon>
            Nova Proposta
          </v-btn>
        </v-flex>
      </v-layout>
      <v-progress-linear
        v-if="loading"
        height="2"
        v-slot:loading
        color="cyan"
        indeterminate
      ></v-progress-linear>
      <v-data-table
        :headers="headers"
        :items="lead.proposals || []"
        item-key="consumer_unit"
        :search="search"
        :loading="loading"
        no-data-text="Não há propostas cadastradas"
        rows-per-page-text="Linhas por página"
        :pagination.sync="pagination"
        v-if="lead.proposals"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template slot="items" slot-scope="{ item }">
          <td>{{ item.updated_at | formatDate }}</td>
          <td>{{ item.name || "-" }}</td>
          <td>{{ item.consumer_unit || "-" }}</td>
          <td>{{ item.installation_number || "-" }}</td>
          <td>{{ item.power_plant ? item.power_plant.name : "-" }}</td>
          <td class="text-xs-right">{{ item.discount + "%" || "-" }}</td>
          <td class="text-xs-right">
            {{ item.percentual_planta + "%" || "-" }}
          </td>
          <td class="text-xs-right">
            <v-icon v-if="!loading" @click="sendEmail(lead, item)">mail</v-icon>
            <v-icon v-if="loading">email-send</v-icon>
            <!-- <img src="@/assets/icons/bill.png" alt="conta" v-if="item.bills">
                    <v-badge overlap color="cyan" v-if="item.bill">
                    <template v-slot:badge>
                        <span>{{item.bill}}</span>
                    </template>
                    <v-icon v-if="!item.bill" @click="enviarEmail(item, process.env.VUE_APP_SENDGRID_TEMPLATE_CONTAPENDENTE)">mail</v-icon>
                    </v-badge>
                    <v-icon v-if="!item.bill && (!item.emailconta || item.emailconta === 0)" @click="enviarEmail(item)">mail</v-icon> -->
          </td>
          <!-- <td>
                    <template>
                    <v-icon 
                        v-if="item.step <= 1"
                        @click="proposta(item, 2)"
                    >
                        access_time
                    </v-icon>
                    <v-icon 
                        v-if="item.step === 2"
                        @click="proposta(item, 3)"
                    >
                        send
                    </v-icon>
                    <v-icon 
                        color="blue"
                        v-if="item.step === 3"
                    >
                        done
                    </v-icon>
                    </template>
                </td> -->
          <!--<td><v-icon @click="getLeadDetail(item.email)">visibility</v-icon></td>-->
          <td><v-icon @click.prevent="proposalSelected(item)">edit</v-icon></td>
        </template>
        <v-alert v-slot:no-results :value="true" color="error" icon="warning">
          Sua busca para "{{ search }}" não retornou resultados.
        </v-alert>
        <template v-slot:pageText="items">
          Linhas {{ items.pageStart }} - {{ items.pageStop }} de
          {{ items.itemsLength }}
        </template>
      </v-data-table>
    </material-card>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-flex>
</template>
<script>
import moment from "moment";
import { enviarEmail } from "../../services/sendmail";
import { eventBus } from "../../main";

export default {
  data: () => ({
    search: "",
    loading: false,
    lead: {},
    headers: [
      {
        sortable: true,
        text: "Atualizado",
        value: "updated_at",
      },
      {
        sortable: true,
        text: "Nome",
        value: "name",
      },
      {
        sortable: false,
        text: "Unidade Consumidora",
        value: "consumer_unit",
      },
      {
        sortable: true,
        text: "Cliente",
        value: "installation_number",
      },
      {
        sortable: true,
        text: "Planta",
        value: "power_plant.name",
      },
      {
        sortable: true,
        text: "% de Desconto",
        value: "discount",
        align: "right",
      },
      {
        sortable: true,
        text: "% da Planta",
        value: "percentual_planta",
        align: "right",
      },
      {
        text: "",
        sortable: false,
        name: "contas",
      },
      {
        text: "  ",
        sortable: false,
        name: "step",
      },
      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
    ],
    pagination: {
      sortBy: "item.updated_at",
      rowsPerPage: 10,
    },
    snack: {
      color: null,
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    },
  }),
  created() {
    eventBus.$on("leadSelected", (lead) => {
      this.lead = lead;
    });
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      if (typeof value === "string") {
        return moment(value).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object

      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
  methods: {
    proposalSelected(proposal) {
      eventBus.$emit("proposal", { type: "edit", data: proposal });
    },
    newProposal() {
      eventBus.$emit("proposal", { type: "new", data: {} });
    },
    formatCurrencyEmail(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async sendEmail(lead, proposal) {
      this.loading = true;
      const data_email = {
        email: lead.email,
        name: lead.name,
        dynamic_template_data: {
          name: lead.name,
          email: lead.email,
          average: proposal.average.toFixed(0),
          custo_disp: proposal.custo_disp,
          desvio_padrao: proposal.desvio_padrao.toFixed(0),
          creditos: proposal.creditos,
          desconto: proposal.discount,
          economia_mensal: this.formatCurrencyEmail(proposal.economia_mensal),
          economia_total: this.formatCurrencyEmail(proposal.economia_contrato),
          email_lead: lead.email,
          consumer_unit: proposal.consumer_unit,
        },
        template_id: process.env.VUE_APP_SENDGRID_TEMPLATE_PROPOSTA2019,
      };
      await enviarEmail(data_email)
        .then(() => {
          this.show_snack("Proposta enviada com sucesso!", "success", "top");
          this.loading = false;
        })
        .catch((error) => {
          this.show_snack("Erro ao enviar proposta!", "error", "top");
          this.loading = false;
          console.error(error);
        });
    },
    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
  },
};
</script>
